export default (function () {
  $('.how-it-works__step .number').each(function (index, item) {
    $(item).text(index + 1);
  });
  $('.steps__item .number').each(function (index, item) {
    $(item).text(index + 1);
  });
});